export enum EntityType {
  USER = "user",
  COMPANY = "company",
  INVENTORY = "inventory",
}
